import type { Axis } from './Axis';
import type { PointObject } from './IPoint';
import type { RectLTWH, RectObject } from './IRect';
import { LineSegment } from './LineSegment';
import { Point } from './Point';
import { Rect } from './Rect';
import type { Size } from './Size';

export function point(
  a:
    | number
    | [number, number]
    | { x: number; y: number }
    | { axis: Axis; major: number; minor: number }
    | Point
    | Float32Array = 0,
  b?: number
): Point {
  return new Point(a, b);
}

export function rect(
  left:
    | number
    | [number, number, number, number]
    | Rect
    | Float32Array
    | [PointObject, PointObject]
    | { center: Point; size: Size }
    | RectObject
    | RectLTWH = 0,
  top?: number,
  right?: number,
  bottom?: number
) {
  return new Rect(left, top, right, bottom);
}

export function lineSegment(p1: Point, p2: Point): LineSegment;
export function lineSegment(x1: number, y1: number, x2: number, y2: number): LineSegment;
export function lineSegment(
  arg1: Point | number,
  arg2: Point | number,
  arg3?: number,
  arg4?: number
): LineSegment {
  if (
    typeof arg1 === 'number' &&
    typeof arg2 === 'number' &&
    typeof arg3 === 'number' &&
    typeof arg4 === 'number'
  ) {
    return new LineSegment(arg1, arg2, arg3, arg4);
  } else if (arg1 instanceof Point && arg2 instanceof Point) {
    return new LineSegment(arg1, arg2);
  } else {
    throw new Error('Invalid arguments for LineSegment constructor');
  }
}
